import { defineMessages } from 'react-intl';

export default defineMessages({
  moreInfo: {
    id: 'moreInfo',
    defaultMessage: 'More info'
  },
});
